<script>
import { Line } from "vue-chartjs/legacy";

export default {
  extends: Line,
  name: "line-chart",
  props: {
    options: {},
    chartData: {},
    color: { type: String, default: "purple" },
    limit: {
      type: Number,
      default: 30,
    },
    nostyle: {
      default: false,
    },
  },
  data() {
    return {
      colorTokens: {
        // Brand Colors
        green: '#7d0707',
        purple: "#ff3131",
        yellow: "#68d588",

        // Secondary Colors
        orange: "#f58634",
        acqua: "#16d9cc",
        blue: "#2971ff",
        red: "#fa5254",
        pink: "#ff5da2",
      },
    };
  },
  mounted() {
    let auxData = this.setLinesConfig(this.chartData);
    let auxOption = this.setChartOptions(this.options);
    this.renderChart(auxData, auxOption);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        let auxData = this.setLinesConfig(this.chartData);
        let auxOption = this.setChartOptions(this.options);
        this.renderChart(auxData, auxOption);
      },
    },
  },
  methods: {
    setLinesConfig(dataToChange) {
      let auxData = this.$ObjectCopy(dataToChange);
      if (!this.nostyle) {
        let auxIndexColor = Object.values(this.colorTokens);

        Object.values(auxData.datasets).forEach((data, index) => {
          data["pointBorderWidth"] = 0;
          data["pointBorderColor"] = "transparent";
          data["pointBackgroundColor"] = this.hex2rgba(
            auxIndexColor[index],
            "1"
          );
          data["pointHitRadius"] = 10;
          // data["borderWidth"] = 3;
          // data["lineTension"] = 0.3;

          if (auxIndexColor[index]) {
            data["backgroundColor"] = this.hex2rgba(
              auxIndexColor[index],
              "1"
            );
            data["borderColor"] = auxIndexColor[index];
          }
        });

        auxData.datasets[0]["backgroundColor"] = this.hex2rgba(
          this.colorTokens[this.color],
          "1"
        );
        auxData.datasets[0]["borderColor"] = this.colorTokens[this.color];
        auxData.datasets[0]["pointBackgroundColor"] = this.colorTokens[
          this.color
        ];
      }

      return auxData;
    },

    setChartOptions(dataToChange) {
      let auxData = this.$ObjectCopy(dataToChange);

      auxData["layout"] = {
        padding: {
          left: 0,
          right: 12,
          top: 12,
          bottom: 0,
        },
      };

      auxData["plugins"] = {
        legend: {
          position: "bottom",
        },
      };

      // Axes
      auxData["scales"] = {
        x: {
          ticks: {
            align: "left",
            maxTicksLimit: this.limit,
            beginAtZero: true,
            padding: 8,
          },
          grid: {
            display: false,
          },
        },
        y: {
          ticks: {
            maxTicksLimit: 8,
            padding: 4,
          },
          grid: {
            color: "#EFF1F2",
            zeroLineColor: "#EFF1F2",
            drawBorder: false,
            beginAtZero: true,
          },
        },
      };

      return auxData;
    },

    hex2rgba(hex, alpha) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>
